import { createContext, type ComponentType, type Context } from 'react';

export type ModalComponentProps = {
	onClose: () => void;
	shouldCloseOnOverlayClick?: boolean;
	shouldCloseOnEscapePress?: boolean;
	setShouldCloseOnOverlayClick: (shouldCloseOnOverlayClick: boolean) => void;
	setShouldCloseOnEscapePress: (shouldCloseOnEscapePress: boolean) => void;
};

export type ModalComponent = ComponentType<ModalComponentProps>;

/**
 * @deprecated Use Modal EntryPoint API instead instead. https://go/modal-entry-point-api
 * */
export const ModalContext: Context<{
	openModal: (component: ModalComponent) => void;
}> = createContext<{
	openModal: (component: ModalComponent) => void;
}>({
	// Replace with lodash/noop
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	openModal: () => {},
});
